import resources from 'api/resources';
import prismic from './prismic';

export const SUFFIXES = {
  SUCCESS: '_SUCCESS',
  FAIL: '_FAIL',
};

export default {
  resources,
  prismic,
};
